import { useMutation } from '@tanstack/react-query'
import { diffColumbiaTimesheet } from 'api/admin/vndly/diffColumbiaTimesheet'

export const useDiffColumbiaTimesheetMutation = () =>
  useMutation({
    mutationFn: diffColumbiaTimesheet,
  })
